module.exports = __webpack_public_path__ + "static/img/Vector.39c19493.svg";